export const formatDateToDDMMYYYY = (dateString) => {
  if (!dateString) {
    console.warn('Date manquante ou invalide:', dateString);
    return 'Date non disponible';
  }

  // Si la date est déjà au format DD/MM/YYYY, la retourner telle quelle
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateString)) {
    return dateString;
  }

  // Si la date est déjà au format DD-MM-YYYY, la convertir en DD/MM/YYYY
  if (/^\d{2}-\d{2}-\d{4}$/.test(dateString)) {
    return dateString.replace(/-/g, '/');
  }

  // Si la date est au format ISO (par exemple, "2025-05-20T00:00:00.000Z"), extrayez la partie YYYY-MM-DD
  if (dateString.includes('T')) {
    dateString = dateString.split('T')[0];
  }

  // Si c'est au format YYYY-MM-DD, le convertir directement
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
    const [year, month, day] = dateString.split('-');
    return `${day}/${month}/${year}`;
  }

  // Si c'est au format DD/MM/YY (année sur 2 chiffres), le convertir en YYYY
  if (/^\d{2}\/\d{2}\/\d{2}$/.test(dateString)) {
    const [day, month, year] = dateString.split('/');
    // Supposer que 00-30 = 2000-2030, 31-99 = 1931-1999
    const fullYear = parseInt(year) <= 30 ? `20${year}` : `19${year}`;
    return `${day}/${month}/${fullYear}`;
  }

  // Si c'est au format DD-MM-YY (année sur 2 chiffres), le convertir
  if (/^\d{2}-\d{2}-\d{2}$/.test(dateString)) {
    const [day, month, year] = dateString.split('-');
    const fullYear = parseInt(year) <= 30 ? `20${year}` : `19${year}`;
    return `${day}/${month}/${fullYear}`;
  }

  // Pour les autres formats, essayer de parser avec new Date UNIQUEMENT si c'est un format ISO strict
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateString) || dateString.includes('T')) {
    const date = new Date(dateString);
    if (!isNaN(date.getTime())) {
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    }
  }

  console.error('Format de date non reconnu:', dateString);
  return dateString; // Retourner la date originale si aucun format ne correspond
};

export const validateExpenseFields = (amount, date) => {
  if (isNaN(amount) || amount <= 0) {
    return 'Le montant doit être un nombre positif';
  }

  if (!date) {
    return 'La date est requise';
  }

  return null; // Aucune erreur
}; 